import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import {
  PageHeader, Typography, Table, Divider, Button, Image, Col, Row
} from 'antd';
import styled from 'styled-components';
import Spinner from 'components/Spins/Basic';
import RecipeForm from 'containers/computers/form';
import Breadcrumb from 'components/BreadCrumb';
import { fetchTheme, fetchSubTheme } from 'utils/themes';

const {
  Title, Paragraph
} = Typography;

const ImageFile = require('./assets/image.png');

const SimulantComputer = () => {
  const [show, setShow] = useState(false);
  const [themes, setThemes] = useState([]);
  const [subThemes, setSubThemes] = useState([]);

  useEffect(() => {
    fetchTheme()
      .then((apiData) => {
        setThemes(apiData);
        fetchSubTheme()
          .then((data) => {
            setSubThemes(data);
          });
      });
  }, []);

  const presentation = () => {
    const dataSource = [
      {
        key: '1',
        code: 'A B C',
        denree: 'Denrées alimentaires à caractère hydrophile'
      },
      {
        key: '2',
        code: 'D1 D2',
        denree: 'Denrées alimentaires à caractère lipophile'
      },
      {
        key: '3',
        code: 'E',
        denree: 'Denrées alimentaires sèches'
      },
    ];

    const columns = [
      {
        title: 'Codes simulants',
        dataIndex: 'code',
        key: 'code',
      },
      {
        title: 'Denrées',
        dataIndex: 'denree',
        key: 'denree',
      },
    ];

    return (
      <>
        <Row justify="center" type="flex" align="middle">
          <Col xs={24} sm={24} md={24} lg={24} xl={12}>
            <Image src={ImageFile.default} width="100%" preview={false} />
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={8}>
            <Typography>
              <Paragraph style={{ marginBottom: '50px', fontSize: '20px' }}>
                Les matériaux ne migrent pas de la même manière en présence de toutes les denrées alimentaires cependant ils
                doivent respecter des seuils de migration maximales. (Par exemple la migration avec des légumes diffère selon
                qu’ils soient frais ou sous forme de purée).
              </Paragraph>
            </Typography>
          </Col>
        </Row>
        <Typography>
          <Divider />
          <Title level={5}>Les simulants sont affectés à des denrées alimentaires spécifiques</Title>
        </Typography>
        <Table pagination={false} bordered dataSource={dataSource} columns={columns} scroll={{ x: true }} />
        <a
          href="https://eur-lex.europa.eu/LexUriServ/LexUriServ.do?uri=OJ:L:2011:012:0001:0089:FR:PDF"
          target="_blank"
          rel="noreferrer"
          style={{
            display: 'block', color: 'green', paddingTop: '10px', paddingLeft: '5px'
          }}
        >
          *Lien vers la documentation officielle (simulants à partir de la page 75)
        </a>
        <Typography>
          <Paragraph style={{ marginTop: '20px' }}>
            Cette application gratuite qui vous permet de définir la liste des simulants en toute autonomie et respecte
            le caractère confidentiel de vos recettes.
          </Paragraph>
          <Paragraph style={{ marginTop: '20px' }}>
            Utilisez le formulaire ci-après pour y saisir vos ingrédients ainsi que le thème concerné par la denrée.
            À l&apos;issue de votre saisie vous pourrez obtenir votre cahier des charges.
          </Paragraph>
          <Divider />
        </Typography>
      </>
    );
  };

  const renderSpinOrContent = () => {
    if (_.isEmpty(themes) || _.isEmpty(subThemes)) {
      return <Spinner size="large" />;
    }

    return (
      <>
        <PageHeader
          style={{ border: '1px solid #d9d9d9' }}
          title="Calculateur"
          breadcrumb={(
            <Breadcrumb
              items={[
                ['Accueil', '/'],
                ['Calculateur'],
              ]}
            />
          )}
        />
        <InnerContent>
          {show && (
            <RecipeForm themes={themes} subThemes={subThemes} setShow={setShow} />
          )}
          {!show && (
            <>
              {presentation()}
              <Button type="primary" onClick={() => setShow(!show)}>Lancer le formulaire</Button>
            </>
          )}
        </InnerContent>
      </>
    );
  };

  return (
    renderSpinOrContent()
  );
};

export default SimulantComputer;

const InnerContent = styled.div`
  background: #fff;
  margin: 0px;
  margin-top: 20px;
`;
